import { styled } from 'styled-components';

import { useContext, useEffect, useRef, useState } from 'react';
import { Box, Text, SimpleGrid, Flex } from '@chakra-ui/react';

import {ReactComponent as iconPrev} from "../assets/icons/icon-arrow-left.svg";
import {ReactComponent as iconNext} from "../assets/icons/icon-arrow-right.svg";
import { ScreenContext } from './ScreenProvider';
import { convertFontSize } from './Util';


const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 33vw;
  min-height: 33vw;
  max-height: 33vw;
  overflow: hidden;

  @media (max-width: 1024px) {
    min-height: 350px;
    height: 48vw;
    max-height: 48vw;
  }

  @media (max-width: 768px) {
    min-height: 100vw;
    height: 100%;
    max-height: 768px;
  }
`;

const SlideWrapper = styled.div<{ $index: number }>`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;

  transform: translateX(-${(props)=>props.$index * 100}%);
  transition: transform 0.5s ease-in-out;
`;

const Slide = styled.div`
  width: 100%;  
  min-width: 100%;
  height: 100%;
  text-align: center;
  font-size: 2vw;
  color: #EFEFEF;

  display: flex;
  justify-content: center;
  align-items: center;
`;

const ArrowPrev = styled(iconPrev)<{ $isactive: string }>`
  max-height: 50px;
  fill: ${(props) => props.$isactive === "true" ? "#969696" : "#ffffff"};
  cursor: ${(props) => props.$isactive === "true" ? "default" : "pointer"};
  &:hover {
    fill: ${(props) => props.$isactive === "true" ? "#969696" : "#27C4D5"};
  }
  @media (max-width: 1024px) {
    max-height: 38px;
  }
  @media (max-width: 768px) {
    max-width: 20px;
    max-height: 20px;
  }
`;

const ArrowNext = styled(iconNext)<{ $isactive: string }>`
  max-height: 50px;
  fill: ${(props) => props.$isactive === "true" ? "#969696" : "#ffffff"};
  cursor: ${(props) => props.$isactive === "true" ? "default" : "pointer"};
  &:hover {
    fill: ${(props) => props.$isactive === "true" ? "#969696" : "#27C4D5"};
  }
  @media (max-width: 1024px) {
    max-height: 38px;
  }
  @media (max-width: 768px) {
    max-width: 20px;
    max-height: 20px;
  }
`;

const SlideBanner = ({
  datas,
  type,
  callbackFunc,
}) => {
  const screen = useContext(ScreenContext).style;
  const sizes = {
    pc: convertFontSize(14, 24, screen),
    tablet: convertFontSize(11, 16, screen),
    mobile: convertFontSize(11, 18, screen)
  };
  const [slideId, setSlideId] = useState<number>(0);
  const isBeginning = datas[0].path === type;
  const isEnd = datas[datas.length - 1].path === type;
  const slideRef = useRef(null);

  const handlePrev = () => {
    if(isBeginning) return;
    setSlideId(prev => prev - 1);
  };

  const handleNext = () => {
    if(isEnd) return;
    setSlideId(prev => prev + 1);
  };

  useEffect(() => {
    if(type && type !== "") {
      setSlideId(datas.findIndex(d => d.path === type));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  useEffect(() => {
    callbackFunc(datas[slideId].path);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slideId]);

  return (
    <Container>
      <SlideWrapper ref={slideRef} $index={slideId} onTouchMove={(e) => e.preventDefault()}>
        {/* <div className='swiper-wrapper'> */}
          {datas?.map((item, index) => {
            return (              
              <Slide key={index} id={`slide${index}`} className={"slide"}>
                <Box 
                  display={"flex"}
                  alignItems={screen === "mobile" ? "start" : "center"}
                  w={"100%"} 
                  h={"100%"} 
                  backgroundImage={`url('${item.bg[screen]}')`} 
                  backgroundSize={"100% 100%"}
                  backgroundPosition={"center"}
                  backgroundRepeat={"no-repeat"}
                  padding={"5%"}
                >
                  {screen !== "mobile" &&
                    <Box
                      display={"flex"}
                      justifyContent={"center"}
                      alignItems={"end"}
                      w={"60%"} 
                      h={"100%"}
                      fontSize={"60px"}
                    >
                    </Box>
                  }
                  <Box
                    display={"flex"}
                    flexDir={"column"}
                    justifyContent={"space-evenly"}
                    alignItems={"start"}
                    p={screen === "mobile" ? "3%" : 0}
                    w={screen === "mobile" ? "100%" : "40%"} 
                    h={screen === "mobile" ? "60%" : "100%"}
                  >
                    <Text fontSize={screen === "mobile" ? "12px" : "24px"} mb={screen === "mobile" ? "3%" : "20px"}>{item.desc.title}</Text>
                    <Text textAlign={"left"} mb={screen === "mobile" ? "2%" : "20px"} fontSize={sizes[screen]} lineHeight={1.5} whiteSpace={"pre-wrap"}>{item.desc.desc}</Text>
                    <SimpleGrid w={"100%"} columns={screen !== "pc" ? 3 : 4} gap={screen === "mobile" ? 2 : 3}>
                    {item.desc.tag.map((tag, tId) => {
                      return (
                        <Box 
                          key={tId} 
                          fontSize={screen !== "pc" ? convertFontSize(10, 12, screen) : convertFontSize(11, 14)} 
                          backgroundColor={"#D9D9D9"} 
                          color={"#1B1B1B"} 
                          borderRadius={"30px"} 
                          padding={screen !== "pc" ? "7px" : "10px"}
                          display={"flex"}
                          justifyContent={"center"}
                          alignItems={"center"}
                        >
                          #{tag.replace(" Test", "")}
                        </Box>
                      )
                    })}
                    </SimpleGrid>
                  </Box>
                </Box>
              </Slide>              
            )
          })}
        {/* </div> */}
      </SlideWrapper>
      <Flex position={"absolute"} w={"100%"} p={"0 2%"} justifyContent={"space-between"}>
        <ArrowPrev $isactive={isBeginning.toString()} onClick={handlePrev} style={{ top: "calc(50% - 28px)" }} />
        <ArrowNext $isactive={isEnd.toString()} onClick={handleNext} style={{ top: "calc(50% - 28px)" }} />
      </Flex>
    </Container>
  );
};

export default SlideBanner;